import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { SearchButton, SearchPanelDiv } from './style';
import { useMediaQuery } from "@chakra-ui/react";

import search from '../../../assets/images/icons/search.svg';
import search_g from "../../../assets/images/icons/search_g.svg";
import search_w from "../../../assets/images/icons/search_w.svg";
import arrow from "../../../assets/images/icons/arrow_right_g.svg";
import close from "../../../assets/images/icons/close_w.svg";
import { theme } from '../../../assets/style/theme';

type Props = {
};

const keywords = [
  '풀씨아카데미',
  '아카데미',
  '풀꽃',
  '환경학술포럼',
  '풀씨',
  '풀씨아카데미',
  '시민과학풀씨',
  '아카데미',
  '환경학술포럼',
  '시민과학풀씨',
]

function Search({  }: Props) {
  const [showPanel, setShowPanel] = useState(false);
  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
    setValue,
    setFocus
  } = useForm();

  const onSubmit = (values:any) => {
    window.location.href = `/search?keyword=${values.keyword}`;
  }

  const onClickKeyword = (keyword:string) => {		
    setValue('keyword', keyword);
  }

  useEffect(() => {
    if (showPanel) {
      setFocus('keyword');
    }
  }, [showPanel])

  return (
    <>
      <SearchButton>
        <button onClick={() => setShowPanel(true)}>
          {
            isMobile ? (
              <img src={search_w} width="18"/>
              ) : (
              <img src={search} width="32"/>
            )
          }
        </button>
      </SearchButton>
      {
        showPanel && (
          <SearchPanelDiv>
            <div className="form">
              <form name="searchForm" onSubmit={handleSubmit(onSubmit)}>
                <img src={search_g} width="32" className="icon" />
                <input
                  id='keyword'
                  placeholder='검색어를 입력해주세요.'
                  {...register('keyword', { required: true })}
                />
                <button type="submit">
                  <img src={arrow} width="32" />
                </button>
              </form>

              <div className="keywords">
                <h1>추천검색어</h1>
                <ul>
                  {
                    keywords.map((item:any, index:number) => (
                      <li key={index} onClick={() => {onClickKeyword(item)}}>
                        <button>
                          {item}
                        </button>
                      </li>
                    ))
                  }
                </ul>
              </div>
            </div>
            <button className="close" onClick={() => {setShowPanel(false)}} >
              <img src={close} width="20" />
            </button>
          </SearchPanelDiv>
        )
      }
    </>
  );
}

Search.defaultProps = {
};

export default Search;
